module.exports = __webpack_public_path__ + "media/images/categories/color/apr-sm-5caf5d4a40e2b609a7f311ed7301b876.png";